<script>
	import { onMount } from 'svelte';

	const SORT_ORDER_DESCENDING = 'descending'
	const STYLE_CLASS_SORTABLE = 'sortable'
	const STYLE_CLASS_ASCENDING = 'ascending'
	const STYLE_CLASS_DESCENDING = 'descending'

	export let items;

	let styleClass = '';
	export { styleClass as class }
	export let containerClass = '';
	export let headClass = null;
	export let footClass = null;
	export let id = 'sortable-table-' + Math.random().toString(36).substring(5);

	let thead;
	let sortOrder;
	let reversed;

	$: sortedItems = sortItems([...items], sortOrder, reversed);

	function sortItems(array, column, reverse) {
		let result = reverse ? -1 : 1;
		return items.sort((a, b) => {
			if (typeof a[column] === 'string') {
				return result * a[column].localeCompare(b[column]);
			}
			if (typeof b[column] === 'string') {
				return -result * b[column].localeCompare(a[column]);
			}
			if (a[column] < b[column]) {
				return -result;
			}
			if (a[column] > b[column]) {
				return result;
			}
			return 0;
		});
	};

	function updateSortClass(sort) {
		reversed = !reversed && sortOrder === sort;
		sortOrder = sort;

		const th = thead.getElementsByTagName('th');
		for (let i = 0; i < th.length; i++) {
			th[i].classList.remove(STYLE_CLASS_ASCENDING);
			th[i].classList.remove(STYLE_CLASS_DESCENDING);
			if (th[i].dataset.sort === sortOrder) {
				th[i].classList.add(reversed ? STYLE_CLASS_DESCENDING : STYLE_CLASS_ASCENDING);
			}
		}
	}

	function addSorterIcon(th, rightAligned, iconClass, textClass) {
		let sorter = document.createElement('i');
		sorter.classList.add('m-1', 'fas', iconClass, textClass);
		if (rightAligned) {
			th.insertBefore(sorter, th.firstChild);
		} else {
			th.appendChild(sorter);
		}
	}

	function addSorter(th) {
		let rightAligned = th.classList.contains('text-right');
		addSorterIcon(th, rightAligned, 'fa-sort-up', 'text-white');
		addSorterIcon(th, rightAligned, 'fa-sort-down', 'text-white');
		addSorterIcon(th, rightAligned, 'fa-sort', 'text-white-50');
	}

	onMount(() => {
		const th = thead.getElementsByTagName('th');
		for (let i = 0; i < th.length; i++) {
			if (th[i].dataset.sort) {
				addSorter(th[i]);
				th[i].classList.add(STYLE_CLASS_SORTABLE);
				th[i].onclick = (event) => updateSortClass(th[i].dataset.sort);
			}
			if (th[i].dataset.sortInitial === SORT_ORDER_DESCENDING) {
				th[i].classList.add(STYLE_CLASS_DESCENDING);
				sortOrder = th[i].dataset.sort;
				reversed = true;
			} else if (th[i].dataset.sortInitial != undefined) {
				th[i].classList.add(STYLE_CLASS_ASCENDING);
				sortOrder = th[i].dataset.sort;
				reversed = false;
			}
		}
	})
</script>

<style>
	:global(th.sortable) {
		cursor: pointer;
		user-select: none;
	}

	:global(th.sortable .fa-sort-up),
	:global(th.sortable .fa-sort-down),
	:global(th.sortable.ascending .fa-sort),
	:global(th.sortable.ascending .fa-sort-down),
	:global(th.sortable.descending .fa-sort),
	:global(th.sortable.descending .fa-sort-up) {
		display: none;
	}

	:global(th.sortable.ascending .fa-sort-up),
	:global(th.sortable.descending .fa-sort-down) {
		display: inline-block;
	}

	:global(.table-responsive-xl th) {
		white-space: nowrap;
	}
</style>

<div {id} class="table-responsive-xl {containerClass}">
	<table class={styleClass}>
		<thead class={headClass} bind:this={thead}>
			<slot name="thead"/>
		</thead>
		<tbody>
			{#each sortedItems as item}
				<slot name="tbody" {item}/>
			{/each}
		</tbody>
		<tfoot class={footClass}>
			<slot name="tfoot"/>
		</tfoot>
	</table>
</div>
